<div *ngIf="open">
  <div cdkDrag class="uploading-panel" [@slideInOut] data-cy="uploading-panel">
    <div cdkDragHandle class="grid-x align-justify align-middle upload-title">
      <div class="cell small-9 upload-text">
        {{ summary }}
      </div>
      <div class="cell small-3 upload-right-item">
        <rav-icon
          name="arrow-down-c"
          class="upload-action"
          *ngIf="this.status.importingJobs && shouldShowStatus"
          (click)="shouldShowStatus = !shouldShowStatus"
        >
        </rav-icon>
        <rav-icon
          name="arrow-up-c"
          class="upload-action"
          *ngIf="!shouldShowStatus"
          (click)="shouldShowStatus = !shouldShowStatus"
        >
        </rav-icon>
        <div class="cancel-button" *ngIf="shouldShowStatus && !this.status.importingJobs" (click)="close()">
          <div class="cancel-button-sub">
            <div class="cancel-button-background"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="upload-content">
      <div *ngFor="let job of status.jobs">
        <div *ngIf="shouldShowStatus && !job.fileName" [routerLink]="job.isFinished && job.redirectUrl">
          <div class="grid-x align-justify align-middle upload-content__item">
            <div class="cell small-1">
              <rav-icon *ngIf="!job.fileName" name="folder" class="sidebar__icon dark-color"> </rav-icon>
            </div>
            <div class="cell small-2 upload-text">
              <span>{{ job.folderName }}</span>
            </div>
            <div class="cell small-3 upload-text upload-right-item">
              <span>{{ job.fileImported }} of {{ job.totalFiles }}</span>
            </div>

            <div *ngIf="!job.isFinished" class="cell small-2 upload-text upload-right-item">
              <img class="upload-right-icon" src="/assets/images/loading.gif" alt="Importing" />
            </div>
            <div *ngIf="job.isFinished" class="cell small-2">
              <rav-icon
                *ngIf="job.fileImported === job.totalFiles"
                class="upload-right-icon-success"
                name="check-mark-c"
              >
              </rav-icon>
              <rav-icon
                *ngIf="job.fileImported !== job.totalFiles"
                class="upload-right-icon-failure"
                name="editor-cancel"
              >
              </rav-icon>
            </div>
          </div>
        </div>
        <div *ngIf="shouldShowStatus && job.fileName" [routerLink]="job.isFinished && job.redirectUrl">
          <div class="grid-x align-justify align-middle upload-content__item">
            <div class="cell small-1">
              <rav-icon
                *ngIf="job.fileName"
                [name]="job?.file?.type === 'application/pdf' ? 'pdf-document' : 'image-document'"
                [title]="job?.file?.type === 'application/pdf' ? 'PDF' : 'Image'"
                class="sidebar__icon dark-color"
              >
              </rav-icon>
            </div>
            <div class="cell small-6 upload-text">
              <span *ngIf="job.fileName">{{ job.fileName }}</span>
            </div>

            <div *ngIf="!job.isFinished" class="cell small-2 upload-text upload-right-item">
              <img class="upload-right-icon" src="/assets/images/loading.gif" alt="Importing" />
            </div>
            <div *ngIf="job.isFinished" class="cell small-2">
              <rav-icon *ngIf="!job.isFailed" class="upload-right-icon-success" name="check-mark-c"> </rav-icon>
              <rav-icon *ngIf="job.isFailed" class="upload-right-icon-failure" name="cancel-c"> </rav-icon>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
      </div>
    </div>
  </div>
</div>
